import './src/styles/global.css'
import "@fontsource/montserrat/800.css"
import "@fontsource/montserrat"
import "typeface-nunito-sans";
import { Analytics } from '@vercel/analytics/react';
import React, { useEffect } from 'react';
import crispChatInit from './src/utils/crisp';

export const wrapRootElement = ({ element }) => {
  return (
    <>
      {element}
      <Analytics />
      <CrispInitializer />
    </>
  );
};

const CrispInitializer = () => {
  useEffect(() => {
    crispChatInit();
  }, []);
  
  return null;
};
